import React from 'react';
import { Tooltip } from 'antd';
import { truncate } from 'lodash';

// =============================================================================
// TransactionCampaignTabs — top-level campaign switcher on the V2 Transactions
// tab. Renders "All" + one pill per child campaign. Multi-campaign orders
// use this to pivot between aggregate and per-campaign Transactions views.
//
// Migrated from AntD <Tabs> to the v2 `.segmented-tabs` primitive for visual
// parity with the rest of this tab's pill controls (date range selector,
// chart mode toggle, attribution method filters). Tooltips show the full
// campaign name for truncated pill labels; the row scrolls horizontally on
// overflow so many campaigns still fit.
// =============================================================================

const TRUNCATE_LEN = 24;

const TransactionCampaignTabs = ({ campaigns, campaignIndex, setCampaignIndex }) => {
  return (
    <div className="campaign-overview__campaign-tabs">
      <div
        className="segmented-tabs campaign-overview__campaign-tabs-group"
        role="tablist"
        aria-label="Campaign switcher"
      >
        <button
          key="All"
          role="tab"
          type="button"
          aria-selected={campaignIndex === 'All'}
          onClick={() => setCampaignIndex('All')}
          className={
            'segmented-tabs__btn' +
            (campaignIndex === 'All' ? ' segmented-tabs__btn--active' : '')
          }
        >
          All
        </button>

        {campaigns?.map((campaign, i) => {
          const label = campaign.campaignName || `Campaign ${i + 1}`;
          const key = i.toString();
          const isActive = campaignIndex === key;
          const display = truncate(label, { length: TRUNCATE_LEN });
          const isTruncated = display !== label;

          const btn = (
            <button
              key={key}
              role="tab"
              type="button"
              aria-selected={isActive}
              onClick={() => setCampaignIndex(key)}
              className={
                'segmented-tabs__btn' +
                (isActive ? ' segmented-tabs__btn--active' : '')
              }
            >
              {display}
            </button>
          );

          return isTruncated ? (
            <Tooltip key={key} overlayClassName="mjl-ds" title={label}>
              {btn}
            </Tooltip>
          ) : (
            btn
          );
        })}
      </div>
    </div>
  );
};

export default TransactionCampaignTabs;
